module.exports = "/images/delete-icon.svg?d12cbd76166c48c1c57dd156413eb15c";